import React from "react";
import { Container } from "./styled";
import { calculatePercj } from "../../lib/cabbStats";
import { Link } from "react-router-dom";

const TeamStatsTable = ({
  appData,
  games,
  activeProfile,
  activeSeason,
  activePhase,
  gamesPlayed,
  gamesWonByTeam,
  isStatsPage,
  isAdvancedStats,
  isDNDTool,
}) => {
  const calculateLastWinningStreak = (gameTipe) => {
    let streak = 0;
    let won = 0;
    let played = 0;

    if (games !== null && games !== undefined) {
      for (const game of games?.filter(
        (game) =>
          (game.local_team === (activeProfile?._id || activeProfile) ||
            game.visit_team === (activeProfile?._id || activeProfile)) &&
          game.season === activeSeason
      )) {
        played++;
        const localPoints = game.local_stats.reduce(
          (sum, stat) => sum + stat.pts,
          0
        );
        const visitPoints = game.visit_stats.reduce(
          (sum, stat) => sum + stat.pts,
          0
        );

        if (
          game.local_team === (activeProfile?._id || activeProfile) &&
          localPoints > visitPoints
        ) {
          won++;
          streak++;
        } else if (
          game.visit_team === (activeProfile?._id || activeProfile) &&
          visitPoints > localPoints
        ) {
          won++;
          streak++;
        } else {
          streak = 0;
        }
      }
      if (gameTipe === "gamesWon") return won;
      else if (gameTipe === "gamesLost") return played - won;
      else if (gameTipe === "gamesPlayed") return played;
      else return streak;
    } else return 0;
  };

  return (
    <Container
      isStatsPage={isStatsPage}
      isContainer={true}
      isAdvancedStats={isAdvancedStats}
      isDNDTool={isDNDTool}
    >
      {!isAdvancedStats ? (
        <div
          className="basic-stats-container"
          isContainer={true}
          isStatsPage={isStatsPage}
        >
          <div className="data-object">
            <p className="data-title">MPP</p>
            <p className="data-value">
              {calculatePercj(
                games?.filter(
                  (game) =>
                    (game.local_team ===
                      (activeProfile?._id || activeProfile) ||
                      game.visit_team ===
                        (activeProfile?._id || activeProfile)) &&
                    game.season === activeSeason &&
                    (activePhase === null || game.stage === activePhase)
                ),
                activeProfile?._id || activeProfile,
                "MINSP"
              ).toFixed(1)}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">PTS</p>
            <p className="data-value">
              {calculatePercj(
                games?.filter(
                  (game) =>
                    (game.local_team ===
                      (activeProfile?._id || activeProfile) ||
                      game.visit_team ===
                        (activeProfile?._id || activeProfile)) &&
                    game.season === activeSeason &&
                    (activePhase === null || game.stage === activePhase)
                ),
                activeProfile?._id || activeProfile,
                "PTS"
              ).toFixed(1)}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">FG</p>
            <p className="data-value">
              {calculatePercj(
                games?.filter(
                  (game) =>
                    (game.local_team ===
                      (activeProfile?._id || activeProfile) ||
                      game.visit_team ===
                        (activeProfile?._id || activeProfile)) &&
                    game.season === activeSeason &&
                    (activePhase === null || game.stage === activePhase)
                ),
                activeProfile?._id || activeProfile,
                "FG"
              ).toFixed(1)}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">FG%</p>
            <p className="data-value">
              {calculatePercj(
                games?.filter(
                  (game) =>
                    (game.local_team ===
                      (activeProfile?._id || activeProfile) ||
                      game.visit_team ===
                        (activeProfile?._id || activeProfile)) &&
                    game.season === activeSeason &&
                    (activePhase === null || game.stage === activePhase)
                ),
                activeProfile?._id || activeProfile,
                "FGP"
              ).toFixed(1)}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">FT</p>
            <p className="data-value">
              {calculatePercj(
                games?.filter(
                  (game) =>
                    (game.local_team ===
                      (activeProfile?._id || activeProfile) ||
                      game.visit_team ===
                        (activeProfile?._id || activeProfile)) &&
                    game.season === activeSeason &&
                    (activePhase === null || game.stage === activePhase)
                ),
                activeProfile?._id || activeProfile,
                "FT"
              ).toFixed(1)}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">FT%</p>
            <p className="data-value">
              {calculatePercj(
                games?.filter(
                  (game) =>
                    (game.local_team ===
                      (activeProfile?._id || activeProfile) ||
                      game.visit_team ===
                        (activeProfile?._id || activeProfile)) &&
                    game.season === activeSeason &&
                    (activePhase === null || game.stage === activePhase)
                ),
                activeProfile?._id || activeProfile,
                "FTP"
              ).toFixed(1)}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">2P</p>
            <p className="data-value">
              {calculatePercj(
                games?.filter(
                  (game) =>
                    (game.local_team ===
                      (activeProfile?._id || activeProfile) ||
                      game.visit_team ===
                        (activeProfile?._id || activeProfile)) &&
                    game.season === activeSeason &&
                    (activePhase === null || game.stage === activePhase)
                ),
                activeProfile?._id || activeProfile,
                "TWOOP"
              ).toFixed(1)}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">2P%</p>
            <p className="data-value">
              {calculatePercj(
                games?.filter(
                  (game) =>
                    (game.local_team ===
                      (activeProfile?._id || activeProfile) ||
                      game.visit_team ===
                        (activeProfile?._id || activeProfile)) &&
                    game.season === activeSeason &&
                    (activePhase === null || game.stage === activePhase)
                ),
                activeProfile?._id || activeProfile,
                "TWOOPP"
              ).toFixed(1)}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">3P</p>
            <p className="data-value">
              {calculatePercj(
                games?.filter(
                  (game) =>
                    (game.local_team ===
                      (activeProfile?._id || activeProfile) ||
                      game.visit_team ===
                        (activeProfile?._id || activeProfile)) &&
                    game.season === activeSeason &&
                    (activePhase === null || game.stage === activePhase)
                ),
                activeProfile?._id || activeProfile,
                "THREEP"
              ).toFixed(1)}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">3P%</p>
            <p className="data-value">
              {calculatePercj(
                games?.filter(
                  (game) =>
                    (game.local_team ===
                      (activeProfile?._id || activeProfile) ||
                      game.visit_team ===
                        (activeProfile?._id || activeProfile)) &&
                    game.season === activeSeason &&
                    (activePhase === null || game.stage === activePhase)
                ),
                activeProfile?._id || activeProfile,
                "THREEPP"
              ).toFixed(1)}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">ASI</p>
            <p className="data-value">
              {calculatePercj(
                games?.filter(
                  (game) =>
                    (game.local_team ===
                      (activeProfile?._id || activeProfile) ||
                      game.visit_team ===
                        (activeProfile?._id || activeProfile)) &&
                    game.season === activeSeason &&
                    (activePhase === null || game.stage === activePhase)
                ),
                activeProfile?._id || activeProfile,
                "ASS"
              ).toFixed(1)}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">ROB</p>
            <p className="data-value">
              {calculatePercj(
                games?.filter(
                  (game) =>
                    (game.local_team ===
                      (activeProfile?._id || activeProfile) ||
                      game.visit_team ===
                        (activeProfile?._id || activeProfile)) &&
                    game.season === activeSeason &&
                    (activePhase === null || game.stage === activePhase)
                ),
                activeProfile?._id || activeProfile,
                "STL"
              ).toFixed(1)}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">TAP</p>
            <p className="data-value">
              {calculatePercj(
                games?.filter(
                  (game) =>
                    (game.local_team ===
                      (activeProfile?._id || activeProfile) ||
                      game.visit_team ===
                        (activeProfile?._id || activeProfile)) &&
                    game.season === activeSeason &&
                    (activePhase === null || game.stage === activePhase)
                ),
                activeProfile?._id || activeProfile,
                "BLK"
              ).toFixed(1)}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">FUL</p>
            <p className="data-value">
              {calculatePercj(
                games?.filter(
                  (game) =>
                    (game.local_team ===
                      (activeProfile?._id || activeProfile) ||
                      game.visit_team ===
                        (activeProfile?._id || activeProfile)) &&
                    game.season === activeSeason &&
                    (activePhase === null || game.stage === activePhase)
                ),
                activeProfile?._id || activeProfile,
                "FL"
              ).toFixed(1)}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">ORB</p>
            <p className="data-value">
              {calculatePercj(
                games?.filter(
                  (game) =>
                    (game.local_team ===
                      (activeProfile?._id || activeProfile) ||
                      game.visit_team ===
                        (activeProfile?._id || activeProfile)) &&
                    game.season === activeSeason &&
                    (activePhase === null || game.stage === activePhase)
                ),
                activeProfile?._id || activeProfile,
                "ORB"
              ).toFixed(1)}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">DRB</p>
            <p className="data-value">
              {calculatePercj(
                games?.filter(
                  (game) =>
                    (game.local_team ===
                      (activeProfile?._id || activeProfile) ||
                      game.visit_team ===
                        (activeProfile?._id || activeProfile)) &&
                    game.season === activeSeason &&
                    (activePhase === null || game.stage === activePhase)
                ),
                activeProfile?._id || activeProfile,
                "DRB"
              ).toFixed(1)}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">PER</p>
            <p className="data-value">
              {calculatePercj(
                games?.filter(
                  (game) =>
                    (game.local_team ===
                      (activeProfile?._id || activeProfile) ||
                      game.visit_team ===
                        (activeProfile?._id || activeProfile)) &&
                    game.season === activeSeason &&
                    (activePhase === null || game.stage === activePhase)
                ),
                activeProfile?._id || activeProfile,
                "TORP"
              ).toFixed(1)}
            </p>
          </div>
          <div className="data-object">
            <p className="data-title">VAL</p>
            <p className="data-value">
              {calculatePercj(
                games?.filter(
                  (game) =>
                    (game.local_team ===
                      (activeProfile?._id || activeProfile) ||
                      game.visit_team ===
                        (activeProfile?._id || activeProfile)) &&
                    game.season === activeSeason &&
                    (activePhase === null || game.stage === activePhase)
                ),
                activeProfile?._id || activeProfile,
                "VAL"
              ).toFixed(1)}
            </p>
          </div>
        </div>
      ) : null}
      {isStatsPage || isAdvancedStats ? (
        <>
          {isStatsPage ? <h2>Estadísticas avanzadas</h2> : null}
          <Container
            isStatsPage={isStatsPage}
            isAdvancedStats={isAdvancedStats}
          >
            <div className="advanced-stats-container">
              <div className="data-object">
                <p className="data-title">PJ</p>
                <p className="data-value">
                  {
                    games?.filter(
                      (game) =>
                        (game.local_team ===
                          (activeProfile?._id || activeProfile) ||
                          game.visit_team ===
                            (activeProfile?._id || activeProfile)) &&
                        game.season === activeSeason
                    ).length
                  }
                </p>
              </div>
              <div className="data-object">
                <p className="data-title">PTS</p>
                <p className="data-value">
                  {calculatePercj(
                    games?.filter(
                      (game) =>
                        (game.local_team ===
                          (activeProfile?._id || activeProfile) ||
                          game.visit_team ===
                            (activeProfile?._id || activeProfile)) &&
                        game.season === activeSeason &&
                        (activePhase === null || game.stage === activePhase)
                    ),
                    activeProfile?._id || activeProfile,
                    "PTS"
                  ).toFixed(1)}
                </p>
              </div>
              <div className="data-object">
                <p className="data-title">oPPG</p>
                <p className="data-value">
                  {calculatePercj(
                    games?.filter(
                      (game) =>
                        (game.local_team ===
                          (activeProfile?._id || activeProfile) ||
                          game.visit_team ===
                            (activeProfile?._id || activeProfile)) &&
                        game.season === activeSeason &&
                        (activePhase === null || game.stage === activePhase)
                    ),
                    activeProfile?._id || activeProfile,
                    "OppPTS"
                  ).toFixed(1)}
                </p>
              </div>
              <div className="data-object">
                <p className="data-title">pDIFF</p>
                <p className="data-value">
                  {isNaN(
                    calculatePercj(
                      games?.filter(
                        (game) =>
                          (game.local_team ===
                            (activeProfile?._id || activeProfile) ||
                            game.visit_team ===
                              (activeProfile?._id || activeProfile)) &&
                          game.season === activeSeason &&
                          (activePhase === null || game.stage === activePhase)
                      ),
                      activeProfile?._id || activeProfile,
                      "PTS"
                    ).toFixed(1) -
                      calculatePercj(
                        games?.filter(
                          (game) =>
                            (game.local_team ===
                              (activeProfile?._id || activeProfile) ||
                              game.visit_team ===
                                (activeProfile?._id || activeProfile)) &&
                            game.season === activeSeason &&
                            (activePhase === null || game.stage === activePhase)
                        ),
                        activeProfile?._id || activeProfile,
                        "OppPTS"
                      )
                  )
                    ? 0
                    : (
                        calculatePercj(
                          games?.filter(
                            (game) =>
                              (game.local_team ===
                                (activeProfile?._id || activeProfile) ||
                                game.visit_team ===
                                  (activeProfile?._id || activeProfile)) &&
                              game.season === activeSeason &&
                              (activePhase === null ||
                                game.stage === activePhase)
                          ),
                          activeProfile?._id || activeProfile,
                          "PTS"
                        ) -
                        calculatePercj(
                          games?.filter(
                            (game) =>
                              (game.local_team ===
                                (activeProfile?._id || activeProfile) ||
                                game.visit_team ===
                                  (activeProfile?._id || activeProfile)) &&
                              game.season === activeSeason &&
                              (activePhase === null ||
                                game.stage === activePhase)
                          ),
                          activeProfile?._id || activeProfile,
                          "OppPTS"
                        )
                      ).toFixed(1)}
                </p>
              </div>
              <div className="data-object">
                <p className="data-title">PACE</p>
                <p className="data-value">
                  {isNaN(
                    (200 /
                      calculatePercj(
                        games?.filter(
                          (game) =>
                            (game.local_team ===
                              (activeProfile?._id || activeProfile) ||
                              game.visit_team ===
                                (activeProfile?._id || activeProfile)) &&
                            game.season === activeSeason &&
                            (activePhase === null || game.stage === activePhase)
                        ),
                        activeProfile?._id || activeProfile,
                        "MINSP"
                      )) *
                      (calculatePercj(
                        games?.filter(
                          (game) =>
                            (game.local_team ===
                              (activeProfile?._id || activeProfile) ||
                              game.visit_team ===
                                (activeProfile?._id || activeProfile)) &&
                            game.season === activeSeason &&
                            (activePhase === null || game.stage === activePhase)
                        ),
                        activeProfile?._id || activeProfile,
                        "POSS"
                      ) +
                        calculatePercj(
                          games?.filter(
                            (game) =>
                              (game.local_team ===
                                (activeProfile?._id || activeProfile) ||
                                game.visit_team ===
                                  (activeProfile?._id || activeProfile)) &&
                              game.season === activeSeason &&
                              (activePhase === null ||
                                game.stage === activePhase)
                          ),
                          activeProfile?._id || activeProfile,
                          "POSSOPP"
                        ))
                  )
                    ? 0
                    : (
                        (200 /
                          calculatePercj(
                            games?.filter(
                              (game) =>
                                (game.local_team ===
                                  (activeProfile?._id || activeProfile) ||
                                  game.visit_team ===
                                    (activeProfile?._id || activeProfile)) &&
                                game.season === activeSeason &&
                                (activePhase === null ||
                                  game.stage === activePhase)
                            ),
                            activeProfile?._id || activeProfile,
                            "MINSP"
                          )) *
                        (calculatePercj(
                          games?.filter(
                            (game) =>
                              (game.local_team ===
                                (activeProfile?._id || activeProfile) ||
                                game.visit_team ===
                                  (activeProfile?._id || activeProfile)) &&
                              game.season === activeSeason &&
                              (activePhase === null ||
                                game.stage === activePhase)
                          ),
                          activeProfile?._id || activeProfile,
                          "POSS"
                        ) +
                          calculatePercj(
                            games?.filter(
                              (game) =>
                                (game.local_team ===
                                  (activeProfile?._id || activeProfile) ||
                                  game.visit_team ===
                                    (activeProfile?._id || activeProfile)) &&
                                game.season === activeSeason &&
                                (activePhase === null ||
                                  game.stage === activePhase)
                            ),
                            activeProfile?._id || activeProfile,
                            "POSSOPP"
                          ))
                      ).toFixed(1)}
                </p>
              </div>
              <div className="data-object">
                <p className="data-title">oEFF</p>
                <p className="data-value">
                  {calculatePercj(
                    games?.filter(
                      (game) =>
                        (game.local_team ===
                          (activeProfile?._id || activeProfile) ||
                          game.visit_team ===
                            (activeProfile?._id || activeProfile)) &&
                        game.season === activeSeason &&
                        (activePhase === null || game.stage === activePhase)
                    ),
                    activeProfile?._id || activeProfile,
                    "OFE"
                  ).toFixed(1)}
                </p>
              </div>
              <div className="data-object">
                <p className="data-title">dEFF</p>
                <p className="data-value">
                  {calculatePercj(
                    games?.filter(
                      (game) =>
                        (game.local_team ===
                          (activeProfile?._id || activeProfile) ||
                          game.visit_team ===
                            (activeProfile?._id || activeProfile)) &&
                        game.season === activeSeason &&
                        (activePhase === null || game.stage === activePhase)
                    ),
                    activeProfile?._id || activeProfile,
                    "DFE"
                  ).toFixed(1)}
                </p>
              </div>
              <div className="data-object">
                <p className="data-title">eDIFF</p>
                <p className="data-value">
                  {isNaN(
                    calculatePercj(
                      games?.filter(
                        (game) =>
                          (game.local_team ===
                            (activeProfile?._id || activeProfile) ||
                            game.visit_team ===
                              (activeProfile?._id || activeProfile)) &&
                          game.season === activeSeason &&
                          (activePhase === null || game.stage === activePhase)
                      ),
                      activeProfile?._id || activeProfile,
                      "OFE"
                    ) -
                      calculatePercj(
                        games?.filter(
                          (game) =>
                            (game.local_team ===
                              (activeProfile?._id || activeProfile) ||
                              game.visit_team ===
                                (activeProfile?._id || activeProfile)) &&
                            game.season === activeSeason &&
                            (activePhase === null || game.stage === activePhase)
                        ),
                        activeProfile?._id || activeProfile,
                        "DFE"
                      )
                  )
                    ? 0
                    : (
                        calculatePercj(
                          games?.filter(
                            (game) =>
                              (game.local_team ===
                                (activeProfile?._id || activeProfile) ||
                                game.visit_team ===
                                  (activeProfile?._id || activeProfile)) &&
                              game.season === activeSeason &&
                              (activePhase === null ||
                                game.stage === activePhase)
                          ),
                          activeProfile?._id || activeProfile,
                          "OFE"
                        ) -
                        calculatePercj(
                          games?.filter(
                            (game) =>
                              (game.local_team ===
                                (activeProfile?._id || activeProfile) ||
                                game.visit_team ===
                                  (activeProfile?._id || activeProfile)) &&
                              game.season === activeSeason &&
                              (activePhase === null ||
                                game.stage === activePhase)
                          ),
                          activeProfile?._id || activeProfile,
                          "DFE"
                        )
                      ).toFixed(1)}
                </p>
              </div>
              <div className="data-object">
                <p className="data-title">G</p>
                <p className="data-value">
                  {calculateLastWinningStreak("gamesWon")}
                </p>
              </div>
              <div className="data-object">
                <p className="data-title">P</p>
                <p className="data-value">
                  {calculateLastWinningStreak("gamesLost")}
                </p>
              </div>
              <div className="data-object">
                <p className="data-title">EG%</p>
                <p className="data-value">
                  {isNaN(
                    Math.round(
                      (calculateLastWinningStreak("gamesWon") /
                        calculateLastWinningStreak("gamesPlayed")) *
                        100
                    )
                  )
                    ? 0
                    : Math.round(
                        (calculateLastWinningStreak("gamesWon") /
                          calculateLastWinningStreak("gamesPlayed")) *
                          100
                      )}
                </p>
              </div>
              <div className="data-object">
                <p className="data-title">RACHA</p>
                <p className="data-value">{calculateLastWinningStreak()}</p>
              </div>
            </div>
          </Container>
          <p>
            *Mirá el glosario de estadísticas{" "}
            <Link className="glosary-link" to="/glosary">
              acá
            </Link>
          </p>
        </>
      ) : null}
    </Container>
  );
};

export default TeamStatsTable;
